<template>
  <div class="all_wrap">
    <div class="main">
      <div class="title_wrap">
        <div class="left">个人中心
          <div class="border_bottom"></div>
        </div>
        <div class="right cursor" @click="okDownload" v-if="this.$store.state.TrialAccount === true">前往完善信息，体验爱文本完整服务 →
        </div>

      </div>
      <div class="bottom_wrap">
        <div class="top">
          <div class="top_left">
            <div class="first_count">
              <div class="left_title">账户</div>
              <div class="flex">
                <div class="left_name">账户名称</div>
                <div class="right_content">{{ userInfoList.UserName }}</div>
              </div>
              <div class="flex">
                <div class="left_name">账户类型</div>
                <div class="right_content" v-if="userInfoList.accountType == 3 || userInfoList.accountType == 2">正式账号
                </div>
                <div class="right_content" v-else>试用账号</div>
              </div>
              <div class="flex">
                <div class="left_name">绑定邮箱</div>
                <div class="right_content">{{ userInfoList.userEmail }}</div>
              </div>
            </div>
            <div class="second_safe" v-if="this.$store.state.TrialAccount === false">
              <div class="left_title">安全</div>
              <div class="flex">
                <div class="left_name">手机号码</div>
                <div class="right_content blue_btn cursor" @click="showPhoneDialog()">改绑
                </div>
              </div>
              <div class="flex">
                <div class="left_name">账户密码</div>
                <div class="right_content blue_btn cursor" @click="showPasswordDialog()">
                  修改</div>
              </div>
            </div>
          </div>
          <div class="top_right po_re">
            <div class="right_img">
              <img src="../assets/Group 1166.svg" alt="">
            </div>
            <div class="contact_way">联系方式</div>

            <p style="margin:2px 0 1px 0">
              <span>用户经理：</span>&nbsp;
              <span>刘经斌</span>
              <span style="color: #1366D9">（售前需求对接）</span>
            </p>
            <p style="margin:2px 0 1px 0">
              <span>13391311631</span>&nbsp;
              <span>dataservice@aitexts.com</span>
            </p>
            <div class="serve_wrap">
              <div class="left_serve">
                <div class="blue_title">服务专线：</div>
                <div class="">021-66181082</div>
              </div>
              <div class="serve_img">
                <img src="/img/login/wechat_QRCode_left.png" alt="" width="88px">
              </div>
            </div>
          </div>
        </div>
        <div class="bot">
          <div class="bot_com">
            <!-- <div class="bot_top">
          <p>
            
            <span class="bot_top_left"> <img
            src="../../static/img/databaseimg.png"
            style="width: 24px; height: 24px;"
          />已订阅数据库</span>
            <span class="bot_top_right"> <img
            src="../../static/img/databaseimg.png"
            style="width: 24px; height: 24px;"
          />未订阅数据库</span>
        </p>
        </div> -->
            <div style="display: flex;justify-content: space-between;width: 100%;">
              <div class="bot_left">
                <div class="bot_right_com">
                  <!-- <img src="../../static/img/databaseimg.png" style="width: 24px; height: 24px;" /> -->
                  已订阅数据库
                </div>
                <div class="bot_left_show ">
                  <!-- <ul class="pul_left scrollbars">
                    <table class="simpledata_table table-bordered hoverline stickythead" style="width:100%;"
                      cellspacing="0" cellpadding="0">
                      <thead class="theadDivBox">
                        <tr style="background-color: #FFF;">
                          <th>数据库名称</th>
                          <th>过期时间</th>
                        </tr>
                      </thead>
                      <tbody style="min-height:300px;" class="tbodyDiv">

                        <tr v-if="getconterList.length == 0"
                          style="color: rgba(60, 90, 152,.5) !important;text-align: center;width: 100%;font-size: 14px;padding-top: 50px;border-top: 1px solid #e5e5e5;padding-bottom: 50px;">
                          <td colspan="2">
                            <i class="iconfont icon-kulian" style="font-size: 36px;"></i>
                            <p>暂无已订阅库</p>
                          </td>
                        </tr>
                        <tr v-else v-for="(item, index) in getconterList" :key="index">
                          <td>{{ item.database }}</td>
                          <td>{{ item.endDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </ul> -->
                  <el-table :data="getconterList" class="table_wrap" style="width: 498px" height="432px"
                    :cell-style="{ textAlign: 'center', 'font-size': '14px' }"
                    :header-cell-style="{ color: '#515A6E', textAlign: 'center', backgroundColor: '#ECF2FE', border: '1px solid rgba(255, 255, 255, 1)', 'border': 'none', 'font-size': '14px', 'font-weight': '700' }">
                    <el-table-column prop="database" label="数据库名称">
                    </el-table-column>
                    <el-table-column prop="endDate" label="过期时间">
                      <template scope="scope">
                        <div style="color:#1366D9">
                          {{ scope.row.endDate }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="bot_right">
                <div class="bot_right_com">
                  <!-- <img src="../../static/img/databaseimg.png" style="width: 24px; height: 24px;" /> -->
                  未订阅数据库
                </div>
                <div class="bot_right_top">
                  <!-- <ul class="pul_right_top scrollbars">
                    <table class="simpledata_table table-bordered hoverline stickythead" style="width:100%;"
                      cellspacing="0" cellpadding="0">
                      <thead class="theadDivBox">
                        <tr style="background-color: #FFF;">
                          <th>数据库名称</th>
                        </tr>
                      </thead>
                      <tbody class="tbodyDiv">
                        <tr v-if="getNocSubscribe.length == 0"
                          style="color: rgba(60, 90, 152,.5) !important;text-align: center;width: 100%;font-size: 14px;padding-top: 50px;border-top: 1px solid #e5e5e5;padding-bottom: 50px;">
                          <td>
                            <i class="iconfont icon-kulian" style="font-size: 36px;"></i>
                            <p>暂无未订阅库</p>
                          </td>
                        </tr>
                        <tr v-else v-for="(item, index) in getNocSubscribe" :key="index">
                          <td style="text-align: center;">{{ item }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </ul> -->
                  <el-table :data="getNocSubscribe" class="table_wrap" style="width: 498px" height="144px"
                    :cell-style="{ textAlign: 'center', 'font-size': '14px' }"
                    :header-cell-style="{ color: '#515A6E', textAlign: 'center', backgroundColor: '#ECF2FE', border: '1px solid rgba(255, 255, 255, 1)', 'border': 'none', 'font-size': '14px', 'font-weight': '700' }">
                    <el-table-column label="数据库名称">
                      <template scope="scope">
                        <div>
                          {{ scope.row }}
                        </div>
                      </template>
                    </el-table-column>

                  </el-table>
                </div>
                <div class="bot_right_com">
                  <!-- <i style="color:#1677ff;" class="iconfont icon-xiazai2"></i> -->
                  下载记录
                </div>
                <div class="bot_right_bot_top_bot">
                  <!-- <ul class="pul_right scrollbars">
                    <table class="simpledata_table table-bordered hoverline stickythead" style="width:100%;"
                      cellspacing="0" cellpadding="0">
                      <thead class="theadDivBox">
                        <tr style="background-color: #FFF;">
                          <th>数据库名称</th>
                          <th>模块</th>
                          <th>下载时间</th>
                        </tr>
                      </thead>
                      <tbody class="tbodyDiv">
                        <tr v-for="(item, index) in downloadHistory" :key="index">
                          <td>{{ item.dbName }}</td>
                          <td>{{ item.mokuai }}</td>
                          <td>{{ item.dateTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </ul> -->
                  <el-table :data="downloadHistory" class="table_wrap" style="width: 498px" height="192px"
                    :cell-style="{ textAlign: 'center', 'font-size': '14px' }"
                    :header-cell-style="{ color: '#515A6E', textAlign: 'center', backgroundColor: '#ECF2FE', border: '1px solid rgba(255, 255, 255, 1)', 'border': 'none', 'font-size': '14px', 'font-weight': '700' }">
                    <el-table-column prop="dbName" label="数据库名称">
                    </el-table-column>
                    <el-table-column label="模块">
                      <template scope="scope">
                        <div>
                          {{ scope.row.mokuai }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dateTime" label="下载时间">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机改绑 -->
      <el-dialog :visible.sync="phoneFlag">
        <div class="top_wrap">
          <div class="close-btn" @click="closePhoneDialog()">
            <i class="el-icon-close"></i>
          </div>
          <div class="phone_border_bottpm">手机改绑</div>
        </div>
        <div class="content_wrap" v-if="userInfoList.tel == '' || step">
          <div class="group-control" style="width:70%;height: 70%;margin:auto auto;;">
            <form action="#" name="passwordForm" method="post" onsubmit="return false;">
              <div style="margin-top: 40px;">
                <Input @on-enter="handleButtonSubmit" v-model="newphone" placeholder="请输入要绑定的手机号" name="newphone"
                  autocomplete />
              </div>
              <div style="margin-top:20px;">
                <span>
                  <Input @on-enter="handleButtonSubmit" v-model="newcode" placeholder="验证码" name="newcode"
                    style="width:68%; margin-bottom: 2px;" />
                  <button
                    style="width:30% ;height:40px;margin-left: 2%;border-radius: 5px;background-color: #FFF;border: solid transparent;height: 32px; border-color: #DCDEE2;border-width: 1px; box-shadow: none;color: #666666;"
                    id="getcode2" @click="getNewCode()" v-text="codetext" :disabled="disable2"></button>
                </span>
              </div>
              <Button v-on:click="newCodeSubmit"
                style="margin: 40px;width: 80%;text-align: center;background-color:#428BF9;color:#fff;">
                确定
              </Button>
            </form>
          </div>
        </div>
        <div class="content_wrap" v-else>
          <!-- <div class="group-control" style="width:70%;height: 70%;margin:auto auto;;"> -->
          <form action="#" name="passwordForm" method="post" onsubmit="return false;">
            <div style="margin-top: 40px;">
              <Input @on-enter="handleButtonSubmit" v-model="oldphone" placeholder="请输入已经绑定的手机号" name="oldphone"
                autocomplete />
            </div>
            <div style="margin-top:20px;">
              <span>
                <Input @on-enter="handleButtonSubmit" v-model="oldcode" placeholder="验证码" name="oldcode"
                  style="width:68%; margin-bottom: 2px;" />
                <button
                  style="width:30% ;height:40px;margin-left: 2%;border-radius: 5px;background-color: #FFF;border: solid transparent;height: 32px; border-color: #DCDEE2;border-width: 1px; box-shadow: none;color: #666;"
                  id="getcode" @click="getCode()" v-text="buttontext" :disabled="disable"></button>
              </span>
            </div>
            <Button v-on:click="oldCodeSubmit()"
              style="margin: 40px;width: 80%;text-align: center;background-color:#428BF9;color:#fff;">确定
            </Button>
          </form>
        </div>
        <!-- </div> -->
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog :visible.sync="passFlag">
        <div class="dialog-header">
          <div class="close-btn" @click="closePasswordDialog()">
            <i class="el-icon-close"></i>
          </div>
          <div class="pass_border_bottpm">修改密码</div>
        </div>
        <div class="dialog-content">
          <div class="group-control" style="width:100%;height: 60%;margin:auto auto;;">
            <form action="#" name="passwordForm" method="post" onsubmit="return false;">
              <div style="margin-top:20px;height: 40px;">
                <Input style="height: 40px;" @on-enter="handleButtonSubmit" v-model="oldPassword" placeholder="请输入旧密码"
                  name="oldPassword" type="password" autocomplete password />
              </div>
              <div style="margin-top:10px;height: 40px;">
                <Input @on-enter="handleButtonSubmit" v-model="newPassword" placeholder="请输入不小于六位的新密码" type="password"
                  name="newPassword" password />
              </div>
              <div style="margin-top:10px;height: 40px;">
                <Input @on-enter="handleButtonSubmit" v-model="surePassword" placeholder="请再次确认新密码" type="password"
                  name="surePassword" password />
              </div>
              <Button v-on:click="handleButtonSubmit"
                style="margin:20px 0;width: 100%;height: 40px;text-align: center;background-color:#428BF9;color:#fff;">确定
              </Button>
            </form>
          </div>
        </div>
      </el-dialog>



      <!--  全局账号模态框  第一步 -->
      <div class="modal fade" id="model_first" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
        aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
        <div class="modal-dialog" style="background: white;height: 220px;width: 450px;border-radius: 10px">
          <div>
            <div style="text-align: center; margin: 8px">
              <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
                &times;
              </button>
            </div>
            <div style="text-align: center;font-size: 15px;color: #626262;padding-top: 40px;font-family: 黑体">
              尊敬的用户您好，您当前使用的账号为公共试用账号
            </div>
            <div style="text-align: center;font-size: 15px;color: #626262;margin-top: 5px;">
              建议您完善个人信息体验更加完整的服务
            </div>
            <div style="text-align: center;margin-top: 20px">
              <el-button style="width: 40%;height: 39px;font-size: 15px;text-align: center" type="primary"
                @click="information_first">完善信息
              </el-button>
            </div>
            <div style="text-align: center;margin-top: 10px">
              <el-button type="text" style="color: #a2a2a2" @click="loginByFirst">已完善信息？前往登录</el-button>
            </div>
          </div>
        </div>
      </div>

      <!--  全局账号模态框  第二步 -->
      <div class="modal fade" id="model_second" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
        aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
        <div class="modal-dialog"
          style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 410px;width: 480px;border-radius: 10px">
          <div>
            <div style="text-align: center; margin: 8px">
              <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
                &times;
              </button>
            </div>
            <div style="text-align: center;font-size: 22px;color: black;padding-top: 40px;">
              完善个人信息
            </div>
            <div style="text-align: center;font-size: 14px;color: gray;margin-top: 5px;">
              - 体验爱文本完整服务 -
            </div>

            <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px">

              <el-form ref="form_second" :model="form_second">
                <label>手机号码</label>
                <el-form-item>
                  <el-input v-model="form_second.phone" placeholder="请输入手机号码" @input="valPhone"></el-input>
                  <div class="tab_s" id="phoneTip" style="display:none;float:left;height:15px;padding:1px;color: red">
                    *&nbsp;请输入正确的手机号
                  </div>
                </el-form-item>

                <label>验证码</label>
                <el-form-item>
                  <el-row>
                    <el-col :span="18">
                      <el-input v-model="form_second.code" placeholder="请输入验证码" style="padding-right: 12px"></el-input>
                    </el-col>
                    <el-col :span="6">

                      <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;"
                        v-if="time !== 0 && time !== 60">{{ time }}
                      </Button>
                      <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center; height: 40px" v-else>
                        发送验证码
                      </Button>
                    </el-col>
                  </el-row>
                  <div class="tab_s" id="codeTip" style="display:none;float:left;height:15px;padding:1px;color: red">
                    *&nbsp;验证码错误
                  </div>
                </el-form-item>


                <el-form-item style="text-align: center;margin-top: 40px">
                  <el-button type="primary" @click="second_next" style="width: 100%;height: 45px">下一步</el-button>
                </el-form-item>
              </el-form>


              <!--            <label>手机号码</label>-->
              <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
              <!--              <el-input v-model="second_phone" placeholder="请输入手机号码"></el-input>-->
              <!--            </div>-->
              <!--            <label>验证码</label>-->
              <!--            <div style="margin-top: 10px">-->
              <!--              <el-row>-->
              <!--                <el-col :span="18">-->
              <!--                  <el-input v-model="second_code" placeholder="请输入验证码" style="padding-right: 12px"></el-input>-->
              <!--                </el-col>-->
              <!--                <el-col :span="6">-->

              <!--                  <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;"-->
              <!--                          v-if="time!==0 && time!==60">{{ time }}-->
              <!--                  </Button>-->
              <!--                  <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center; height: 40px" v-else>发送验证码-->
              <!--                  </Button>-->
              <!--                </el-col>-->
              <!--              </el-row>-->
              <!--            </div>-->

            </div>

          </div>
        </div>
      </div>

      <!--  全局账号模态框  第三步 -->
      <div class="modal fade" id="model_third" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
        aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
        <div class="modal-dialog"
          style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 610px;width: 480px;border-radius: 10px">
          <div>
            <div style="text-align: center; margin: 8px">
              <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
                &times;
              </button>
            </div>
            <div style="text-align: center;font-size: 22px;color: black;padding-top: 40px;">
              完善个人信息
            </div>
            <div style="text-align: center;font-size: 14px;color: gray;margin-top: 5px;">
              - 体验爱文本完整服务 -
            </div>

            <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px">

              <el-form ref="form_second" :model="form_third">
                <label>密码</label>
                <el-form-item>
                  <el-input placeholder="请设置密码" v-model="form_third.password" show-password
                    @input="passwordTest"></el-input>
                  <div class="tab_s" id="passwordTip" style="display:none;float:left;height:10px;color: red">
                    *&nbsp;密码不能为空
                  </div>
                </el-form-item>

                <label>邮箱</label>
                <el-form-item>
                  <el-input v-model="form_third.email" placeholder="请输入邮箱" @input="emailTest"></el-input>
                  <div class="tab_s" id="emailTip" style="display:none;float:left;height:10px;color: red"> *&nbsp;邮箱格式错误
                  </div>
                </el-form-item>

                <label>学校全称</label>
                <el-form-item>
                  <el-select v-model="form_third.school" filterable placeholder="请选择" style="width: 100%">
                    <el-option v-for="item in schoolNameList" :key="item.id" :label="item.adress" :value="item.adress">
                    </el-option>
                  </el-select>
                  <div class="tab_s" id="schoolTip" style="display:none;float:left;height:10px;color: red">
                    *&nbsp;学校全称不能为空
                  </div>
                </el-form-item>

                <label>身份</label>
                <el-form-item>
                  <el-col :span="6">
                    <el-radio v-model="form_third.identity" label="1" border>教师</el-radio>
                  </el-col>
                  <el-col :span="9">
                    <el-radio v-model="form_third.identity" label="2" border>在读博士生</el-radio>
                  </el-col>
                  <el-col :span="9">
                    <el-radio v-model="form_third.identity" label="3" border>其他研究人员</el-radio>
                  </el-col>
                </el-form-item>


                <el-form-item style="text-align: center;margin-top: 40px">
                  <el-col :span="12" style="padding-right: 15px">
                    <el-button style="width: 100%;height: 40px" @click="lastStep">上一步</el-button>
                  </el-col>
                  <el-col :span="12" style="padding-left: 15px">
                    <el-button type="primary" style="width: 100%;height: 40px" @click="finish">完成</el-button>
                  </el-col>
                </el-form-item>
              </el-form>


              <!--            <label>密码</label>-->
              <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
              <!--              <el-input placeholder="请设置密码" v-model="input" show-password></el-input>-->
              <!--            </div>-->
              <!--            <label>邮箱</label>-->
              <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
              <!--              <el-input v-model="input" placeholder="请输入邮箱"></el-input>-->
              <!--            </div>-->
              <!--            <label>学校全称</label>-->
              <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
              <!--              <el-input v-model="input" placeholder="请输入学校"></el-input>-->
              <!--            </div>-->

              <!--            <label>身份</label>-->
              <!--            <div style="margin-top: 10px;margin-bottom: 45px">-->
              <!--              <el-col :span="6">-->
              <!--                <el-radio v-model="radio1" label="1" border>教师</el-radio>-->
              <!--              </el-col>-->
              <!--              <el-col :span="9">-->
              <!--                <el-radio v-model="radio1" label="2" border>在读博士生</el-radio>-->
              <!--              </el-col>-->
              <!--              <el-col :span="9">-->
              <!--                <el-radio v-model="radio1" label="3" border>其他研究人员</el-radio>-->
              <!--              </el-col>-->
              <!--            </div>-->

              <!--            <div style="text-align: center;padding-top: 40px">-->
              <!--              <el-col :span="12" style="padding-right: 15px">-->
              <!--                <el-button style="width: 100%;height: 40px" @>上一步</el-button>-->
              <!--              </el-col>-->
              <!--              <el-col :span="12" style="padding-left: 15px">-->
              <!--                <el-button type="primary" style="width: 100%;height: 40px">完成</el-button>-->
              <!--              </el-col>-->
              <!--            </div>-->
            </div>
          </div>
        </div>
      </div>
      <!--  全局账号模态框  第四步 -->
      <div class="modal fade" id="model_four" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
        aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
        <div class="modal-dialog"
          style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 310px;width: 480px;border-radius: 10px">
          <div>
            <div style="text-align: center; margin: 8px">
              <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
                &times;
              </button>
            </div>
            <div style="text-align: center;font-size: 22px;color: black;padding-top: 60px;">
              <i style="color: #2d8cf0;font-size: 35px" class="el-icon-success"></i>
            </div>
            <div
              style="text-align: center;font-size: 18px;color: #2d8cf0;margin-top: 10px;font-weight: bold;font-family: 黑体">
              信息完善成功
            </div>
            <div style="text-align: center;font-size: 14px;color: gray;margin-top: 10px">
              已为您开通新账号：用户名为手机号
            </div>
            <div style="text-align: center;font-size: 14px;color: gray;margin-top: 2px;">
              期限为一个月
            </div>

            <div style="padding-left: 50px;padding-right: 50px;padding-top: 30px">
              <div style="text-align: center;">
                <el-button type="primary" style="width: 100%;height: 40px" @click="loginByNewAccount">前往登录新账号
                  <i class="el-icon-right"></i>
                </el-button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- <dialog class="dialog" id="passwordDialog" style="display:none;border:solid 1px #ccc;">
        <div class="dialog-header">
          修改密码
          <div class="close-btn" @click="closePasswordDialog()">x</div>
        </div>
        <div class="dialog-content">
          <div class="group-control" style="width:60%;height: 60%;margin:auto auto;;">
            <form action="#" name="passwordForm" method="post" onsubmit="return false;">
              <div style="margin-top: 55px;">
                <Input @on-enter="handleButtonSubmit" v-model="oldPassword" placeholder="请输入旧密码" name="oldPassword"
                  type="password" autocomplete password />
              </div>
              <div style="margin-top:20px;">
                <Input @on-enter="handleButtonSubmit" v-model="newPassword" placeholder="请输入不小于六位的新密码" type="password"
                  name="newPassword" password />
              </div>
              <div style="margin-top:20px;">
                <Input @on-enter="handleButtonSubmit" v-model="surePassword" placeholder="请再次确认新密码" type="password"
                  name="surePassword" password />
              </div>
              <Button v-on:click="handleButtonSubmit"
                style="margin-top: 35px;width: 30%;text-align: center;margin-left: 35%;">确定
              </Button>
            </form>
          </div>
        </div>
      </dialog>
      <dialog class="dialog" id="phoneDialog" style="display:none;border:solid 1px #ccc;">
        <div class="dialog-header">
          手机改绑
          <div class="close-btn" @click="closePhoneDialog()">x</div>
        </div>

        <div class="dialog-content" v-if="userInfoList.tel == '' || step">
          <div class="group-control" style="width:60%;height: 60%;margin:auto auto;;">
            <form action="#" name="passwordForm" method="post" onsubmit="return false;">
              <div style="margin-top: 80px;">
                <Input @on-enter="handleButtonSubmit" v-model="newphone" placeholder="请输入要绑定的手机号" name="newphone"
                  autocomplete />
              </div>
              <div style="margin-top:20px;">
                <span>
                  <Input @on-enter="handleButtonSubmit" v-model="newcode" placeholder="验证码" name="newcode"
                    style="width:68%; margin-bottom: 2px;" />
                  <button
                    style="width:30% ;margin-left: 2%;border-radius: 5px;background-color: #FFF;
                                                                                                                                                                                                                                                                                                                                       border: solid transparent;
                                                                                                                                                                                                                                                                                                                                       height: 32px; border-color: #DCDEE2;border-width: 1px; box-shadow: none;color: rgb(48, 118, 188);"
                    id="getcode2" @click="getNewCode()" v-text="codetext" :disabled="disable2"></button>
                </span>
              </div>
              <Button v-on:click="newCodeSubmit" style="margin-top: 40px;width: 30%;text-align: center;margin-left: 35%;">
                确定
              </Button>
            </form>
          </div>
        </div>
        <div class="dialog-content" v-else>
          <div class="group-control" style="width:60%;height: 60%;margin:auto auto;;">
            <form action="#" name="passwordForm" method="post" onsubmit="return false;">
              <div style="margin-top: 80px;">
                <Input @on-enter="handleButtonSubmit" v-model="oldphone" placeholder="请输入已经绑定的手机号" name="oldphone"
                  autocomplete />
              </div>
              <div style="margin-top:20px;">
                <span>
                  <Input @on-enter="handleButtonSubmit" v-model="oldcode" placeholder="验证码" name="oldcode"
                    style="width:68%; margin-bottom: 2px;" />
                  <button
                    style="width:30% ;margin-left: 2%;border-radius: 5px;background-color: #FFF;
                                                                                                                                                                                                                                                                                                                                       border: solid transparent;
                                                                                                                                                                                                                                                                                                                                       height: 32px; border-color: #DCDEE2;border-width: 1px; box-shadow: none;color: rgb(48, 118, 188);"
                    id="getcode" @click="getCode()" v-text="buttontext" :disabled="disable"></button>
                </span>
              </div>
              <Button v-on:click="oldCodeSubmit()"
                style="margin-top: 40px;width: 30%;text-align: center;margin-left: 35%;">确定
              </Button>
            </form>
          </div>
        </div>
      </dialog> -->
    </div>
  </div>
</template>

<script>

import act from '@/store/actions'
import store from '@/store'
import axios from "../api/axios";
import { mapMutations, mapActions } from "vuex";
import globalFunction from "../api/globalFunction.js";

export default {
  name: 'personalCenter',
  data() {
    return {
      phoneFlag: false,
      passFlag: false,
      resData: "false",
      getsystemList: [],
      getconterList: [],
      downloadHistory: [],
      getNocSubscribe: [],
      userInfoList: [],
      oldPassword: '',
      newPassword: '',
      surePassword: '',
      newphone: '',
      oldphone: '',
      step: false,
      disable: false,
      disable2: false,
      oldcode: '',
      newcode: '',
      buttontext: "获取验证码",
      codetext: "获取验证码",
      PostData: {
        UserName: '',
        DbName: '',
        mokuai: '',
        caozuo: '',
        keyWords: '',
        // identity: '',
      },



      schoolNameList: [],
      form_second: {
        phone: '',
        code: ''
      },
      form_third: {
        password: '',
        email: '',
        school: '',
        identity: '1',
      },
      time: 60,


      formLabelWidth: '120px',
      minDate: new Date(631123200000),
      maxDate: new Date(),
      showstockcodediv: false,
      stock_loading: true,
      headerList: [],
      dataType: "",
      simpleData: [],
      keyword: "",
      selectYear: [],
      data1: [],
      timeSelect: "NoLimit",
      dictSelect: "ZiDingYiDict",
      selectedYears: [],
      stockCodeSelect: "SelectAll",
      stockCode_selected_temporaryArray: [],
      stockCode_nameArray: [],
      stockCode_name_selected_Array: [],
      stockCode_temporaryArray: [],
      stockCodeUnSelect_serach: "",
      stockCodeSelect_serach: "",
      uploadStockCodeArray: [],
      selectedField: [],
      unselectedField: [],
      unSelect_serach: "",
      select_serach: "",
      previewData: [],
      previewHeaderList: [],
      previewLoading: true,
      downloadCurrentStep: 1,
      downloadTasks: [],
      modalDownload: false,
      errorInfoArray: "",
      params: {},
      downloadTable: '基本信息',
      fileName: '',
      downloadPercentage: 0,
      zipPercentage: 0,
      AuthLevel: 1,
      hasDate: false,
      showAuth: true,
      dataload: false,
      keyListInfoArray: "",
      keyModel: false,





    }
  },
  methods: {
    ...mapMutations(["PUSH_TASKMD5lIST", "SET_USER_SIGNOUT", "SET_ISDOWNLOAD"]),
    ...mapActions(['signOut']),

    okDownload() {
      // let md5 = this.downloadTasks.taskMD5;
      // //修改下载状态为已经下载
      // this.SET_ISDOWNLOAD(md5);
      // axios
      //   .post("/api/getDownloadUrl", { md5: md5 })
      //   .then(response => {
      //     var a = document.createElement("a");
      //     a.href = response.data.data
      //     a.click()
      $("#model_first").modal("show");
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    },
    closePreviewDialog() {
      clearInterval(this.timer);
      // $(".sampleData_table_div").scrollTop(0);
    },
    information_first() {
      //第一步隐藏
      $("#model_first").modal('hide');
      //打开第二步
      $("#model_second").modal();
    },
    loginByFirst() {
      //第二步隐藏
      $("#model_first").modal('hide');
      this.gotoLogin();
    },
    validPhone() {
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!reg.test(this.form_second.phone.trim())) {
        return false;
      } else {
        return true;
      }
    },
    valPhone: globalFunction.debounce(function () {
      var result = this.validPhone();
      if (result) {
        let formData = new FormData();
        formData.append("phone", this.form_second.phone.trim());
        axios({
          method: 'post',
          url: '/api/register/valPhone',
          data: formData,
        }).then((res) => {
          if (res.data.status) {
            $("#phoneTip").hide();
          } else {
            $("#phoneTip").text(res.data.msg);
            $("#phoneTip").show();
          }
        });
      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    }, 1000),
    async sendPhone() {
      var result = this.validPhone();
      if (result) {
        $("#phoneTip").hide();
        await axios.post("/api/register/sendPhoneMessageByredis", {
          phone: this.form_second.phone.trim()
        }).then((res) => {
          if (res.data.status) {
            $('#button1')[0].disabled = true
            // 发送短信后启动定时器
            this.setTime = setInterval(() => {
              //console.log(this.time)
              if (this.time > 0) {
                this.time--
              }
              if (this.time === 0) {
                $('#button1')[0].disabled = false
                clearInterval(this.setTime)
                this.time = 60
              }
            }, 1000);
            $("#phoneTip").hide();
          } else {
            $("#phoneTip").text(res.data.msg);
            $("#phoneTip").show();
          }
        }).catch(() => {
          this.$Message.error("短信发送失败")
        })

      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    },
    second_next() {
      var result = this.validPhone();
      if (result) {
        $("#phoneTip").hide();
        if (this.form_second.code.trim().length == 6) {
          $("#codeTip").hide();
          axios.post("/api/register/valCodeByRedis", {
            code: this.form_second.code.trim(),
            phone: this.form_second.phone.trim()
          }).then((res) => {
            if (res.data.status) {
              //第二步隐藏
              $("#model_second").modal('hide');
              //打开第三步
              $("#model_third").modal();
              $("#codeTip").hide();
            } else {
              $("#codeTip").show();
            }
          });
        } else {
          $("#codeTip").show();
        }

      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    },
    emailTest() {
      if (this.form_third.email.trim().length <= 0) {
        $("#emailTip").show();
      } else {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if (reg.test(this.form_third.email.trim())) {
          $("#emailTip").hide();
        } else {
          $("#emailTip").show();
        }
      }
    },
    //上一步
    lastStep() {
      $("#model_third").modal('hide');
      $("#model_second").modal();
    },
    finish() {
      if (this.form_third.password.trim().length <= 0) {
        $("#passwordTip").show();
        return;
      } else {
        $("#passwordTip").hide();
      }
      if (this.form_third.email.trim().length <= 0) {
        $("#emailTip").show();
        return;
      } else {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if (reg.test(this.form_third.email.trim())) {
          $("#emailTip").hide();
        } else {
          $("#emailTip").show();
          return;
        }
      }
      if (this.form_third.school.trim().length <= 0) {
        $("#schoolTip").show();
        return;
      } else {
        $("#schoolTip").hide();
      }

      axios.post("/api/user/addUser", {
        phone: this.form_second.phone.trim(),
        password: this.form_third.password.trim(),
        email: this.form_third.email.trim(),
        school: this.form_third.school.trim(),
        identity: this.form_third.identity.trim()
      }).then((res) => {
        if (res.data.status) {
          //第二步隐藏
          $("#model_third").modal('hide');
          //打开第三步
          $("#model_four").modal();
        } else {
          this.$message.error('提交失败，请联系客服人员');
        }
      });

    },
    passwordTest() {
      if (this.form_third.password.trim().length <= 0) {
        $("#passwordTip").show();
      } else {
        $("#passwordTip").hide();
      }
    },
    loginByNewAccount() {
      //第二步隐藏
      $("#model_four").modal('hide');
      this.gotoLogin();
    },
    //退出登录并跳转至登录界面
    gotoLogin: async function () {
      $("#roleInfoModal").modal('hide');
      await this.signOut();
      this.SET_USER_SIGNOUT();
      this.$store.state.taskMD5List = []
      window.sessionStorage.removeItem("store")
      this.$router.push('/');
      $.cookie("modalFlag", "", { expires: -1 });
    },

    ...mapActions(['getSystemList', 'historybyperson']),
    // 修改密码
    showPasswordDialog() {
      // 展示
      // $("#passwordDialog").show()
      this.passFlag = true
      // document.querySelector("#passwordDialog").showModal();
      //document.getElementsByClassName('dialog')[0].showModal();
    },

    getInfo(){
      $("#model_first").modal();
      return;
    },

    closePasswordDialog() {

      if ("aitexts.edu.cn" === this.$store.state.userInfo.UserName) {

        return;
      }
      // 隐藏
      // $("#passwordDialog").hide()
      this.passFlag = false

      // document.querySelector("#passwordDialog").close();
      this.oldPassword = ''
      this.newPassword = ''
      this.surePassword = ''
    },
    //改绑手机 
    showPhoneDialog() {
      this.phoneFlag = true
      // 展示
      // $("#phoneDialog").show()
      // document.querySelector("#phoneDialog").showModal();
      //document.getElementsByClassName('dialog')[0].showModal();
    },
    closePhoneDialog() {
      // 隐藏
      // $("#phoneDialog").hide()
      this.phoneFlag = false

      // document.querySelector("#phoneDialog").close();
      this.oldphone = ''
      this.newphone = ''
      this.oldcode = ''
      this.newcode = ''
      this.step = false
      this.disable2 = false
    },
    handleButtonSubmit() {
      if (this.newPassword.trim().length < 6 || this.oldPassword.trim() === '') {
        this.$Message.info('请输入不小于六位的密码！');
        return
      } else if (this.newPassword.trim() != this.surePassword.trim()) {
        this.$Message.info('两次密码输入不一致');
        return
      }
      var params = {
        oldPassword: this.oldPassword.trim(),
        newPassword: this.newPassword.trim()
      }
      //调用接口
      axios.post('/api/reviseInformation', params).then(result => {
        console.log(result)
        if (result.data.status) {
          this.PostData.UserName = this.userInfoList.UserName
          //   this.PostData.name = this.formItem.name
          this.PostData.caozuo = '修改密码'
          //
          axios.post('/api/register/addLog', this.PostData)
            .then((res) => {

            }).catch(() => {
              this.$Message.error('日志写入错误，请重试');
              return
            })
          this.$Message.info(result.data.msg);
          this.closePasswordDialog();
        } else {
          this.$Message.info(result.data.msg);
        }
      });


    },
    //已绑定手机号验证码发送
    getCode() {

      if (this.oldphone != this.userInfoList.tel) {
        this.$Message.error('输入手机号与已绑手机号不符');
        return;
      }
      if (!this.validatePhoneNumber(this.oldphone)) {
        this.$Message.error('请输入正确的手机号');
        return;
      }
      var params = {
        phone: this.oldphone,
      }
      setTimeout(() => {
        //请求发出防抖
        this.disable = true;
      }, 3000);
      axios.post('/api/user/sendPhoneMessage', params).then(result => { //result.data.status
        if (result.data.status) {
          var wait = 60;
          this.$Message.info(result.data.msg);
          let countdown = setInterval(() => {
            if (wait == 0) {
              this.buttontext = "重新获取验证码"
              this.disable = false
              clearInterval(countdown);
            } else {
              this.buttontext = wait + "s后再次获取"
              wait--;
            }
          }, 1000)

        } else {
          this.$Message.info(result.data.msg);
        }
      })
    },
    oldCodeSubmit() {
      if (this.oldphone != this.userInfoList.tel) {
        this.$Message.error('输入手机号与已绑手机号不符');
        return;
      }
      if (!this.validatePhoneNumber(this.oldphone)) {
        this.$Message.error('请输入正确的手机号');
        return;
      }
      var params = {
        phone: this.oldphone,
        code: this.oldcode
      }
      axios.post('/api/user/validCode', params).then(result => {
        if (result.data.status) {
          this.step = true
        }
        this.$Message.info(result.data.data);
      })
    },
    getNewCode() {
      if (this.newphone == this.userInfoList.tel) {
        this.$Message.error('输入手机号已为当前绑定手机号');
        return;
      }
      if (!this.validatePhoneNumber(this.newphone)) {
        this.$Message.error('请输入正确的手机号');
        return;
      }
      var params = {
        phone: this.newphone,
      }
      setTimeout(() => {
        //请求发出防抖
        this.disable2 = true;
      }, 3000);
      axios.post('/api/user/sendNewphoneMessage', params).then(result => { //result.data.status
        if (result.data.status) {
          var wait = 60;
          this.$Message.info(result.data.msg);
          let countdown = setInterval(() => {
            if (wait == 0) {
              this.codetext = "重新获取验证码"
              this.disable2 = false
              clearInterval(countdown);
            } else {
              this.codetext = wait + "s后再次获取"
              wait--;
            }
          }, 1000)

        } else {
          this.$Message.info(result.data.msg);
        }
      })
    },
    ...mapMutations(["SET_USER_LOGIN_INFO"]),
    newCodeSubmit() {


      if (this.newphone == this.userInfoList.tel) {
        this.$Message.error('输入手机号已为当前绑定手机号');
        return;
      }
      if (!this.validatePhoneNumber(this.newphone)) {
        this.$Message.error('请输入正确的手机号');
        return;
      }
      var params = {
        phone: this.newphone,
        code: this.newcode
      }
      axios.post('/api/user/validNewCode', params).then(result => {
        if (result.data.status) {

          this.$Message.info("手机号改绑成功");
          this.SET_USER_LOGIN_INFO(result.data.data);
          this.userInfoList = result.data.data;
          this.closePhoneDialog();
        } else {
          this.$Message.info(result.data.msg);
        }
      })
    },
    validatePhoneNumber(str) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      return reg.test(str)
    },
    //...mapMutations(["SET_USER_LOGIN_INFO"]),
  },

  mounted: async function () {
    this.getSystemList().then(s => {
      this.getsystemList = s.data.SystemList;
      let auths = JSON.parse(JSON.stringify(this.$store.getters.getAuths))
      let auths_arr = []
      for (let sys of auths) {
        if (this.getsystemList[sys.database]) {
          sys.database = this.getsystemList[sys.database].name
          auths_arr.push(sys.database)
        }
      }
      this.getconterList = auths;
      let subsysList = this.getconterList.map(s => s.database)
      let nosub = []
      for (var sys in this.getsystemList) {
        if (auths_arr.indexOf(this.getsystemList[sys].name) == -1 && sys != 'CFND_HighTrailTest') {
          nosub.push(this.getsystemList[sys].name)
        }
      }
      this.getNocSubscribe = nosub
    });
    this.historybyperson().then(s => {
      this.downloadHistory = s.data.data;
    });

    this.userInfoList = this.$store.getters.getuserInfo;
    //  console.log(this.userInfoList)
    // this.getNocSubscribe = this.getsystemList.filter(s=>s.);
    axios.get("/api/register/getSchoolDetailList").then((res) => {
      if (res.status === 200) {
        this.schoolNameList = res.data
      }
    }).catch((e) => {
      console.warn(e)
    })

  }
}
</script>

<style>
.cursor {
  cursor: pointer;
}

.main {

  margin: 0 auto;
  position: relative;
  width: 1200px;
  background: #FFFFFF;
  border-radius: 8px;
}

.top {
  height: 350px;
  margin: 0 auto;
  border-radius: 25px;
  border: 1px solid #fff;
  background-color: #fff;

}

.top_left {
  width: 500px;
  align-items: left;
  float: left;
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */


  /* Grey/grey-400 */

  color: #858D9D;
}

.top_right {
  width: 498px;
  align-items: right;
  float: right;
  background: #F2F6FF;
  border-radius: 4px;
  padding: 30px 34px 20px;
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 32px;
  /* or 213% */


  color: #5D6679;

}

.bot {
  /* height: 650px;*/
  background-color: #fff;
  /*margin-top: 50px;*/
  border-radius: 25px;
  /* padding: 20px;*/
}

/*.bot_com {
 height: 100%;
}*/

.bot_top {
  margin: 0 auto;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 25px;
  height: 30px;
  background-color: #fff;
}

.bot_top_left {
  margin: 2px 40px 2px 40px;
  float: left;
  font-size: 18px;
}

.bot_top_right {
  margin: 2px 40px 2px 40px;
  float: right;
  font-size: 18px;
}

.bot_left {
  width: 100%;
  /*height: 380px;*/
  text-align: center;
}

.bot_right {
  width: 100%;
  /*height: 380px;*/

  padding-left: 20px;
}

.bot_left_show {
  clear: both;
  align-content: center;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.pul_left {
  list-style: none;
  width: 100%;
  height: 420px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto
}

.pul_right {
  width: 100%;
  list-style: none;
  height: 200px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.pul_right_top {
  width: 100%;
  list-style: none;
  height: 150px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.pli {
  clear: both;
  list-style: none;
  width: 100%;
  left: 20px;
  position: relative;
}

.bot_right_top {
  width: 100%;
  height: 150px;
  background-color: #fff;
}

.bot_right_com {
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 25px;
  /* width: 95%; */
  height: 30px;
  text-align: left;
  margin-bottom: 20px;
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #48505E;
}

.bot_right_bot_top {
  display: flex;
  width: 500px;
}

.bot_right_bot_top_bot {
  width: 100%;
  /*height: 140px;*/
}

.theadDivBox th {
  white-space: nowrap;
  border: none !important;
  text-align: center;
  width: 498px;
  height: 40px;
  background: #ECF2FE;
  opacity: 0.5;
  border-bottom: 1px solid #ECF2FE;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #515A6E !important;
}



.table-bordered>thead>tr>th,
.table-bordered>tbody>tr>th,
.table-bordered>tfoot>tr>th,
.table-bordered>thead>tr>td,
.table-bordered>tbody>tr>td,
.table-bordered>tfoot>tr>td {
  line-height: 48px;
  border: none;
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.tbodyDiv {
  background: #fff;
}

.tbodyDiv tr {
  height: 25px;
}

.tbodyDiv td {
  white-space: nowrap;
  padding: 0 10px;
}



/* 固定表头 */
.stickythead {
  border: none !important;
}

.stickythead th {
  position: sticky;
  top: 0;
  background: #ecf2fe;
  border-top: none;
}

.dialog {
  height: 400px;
  width: 600px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  border: none;
  border-radius: 20px;
  padding: 0 20px;
}

.dialog-header {
  height: 50px;
  width: 100%;
  line-height: 50px;
  position: relative;
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #4C4C4C;
  border-bottom: 1px solid #DCDFE6;
}

.close-btn {
  display: inline-block;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  cursor: pointer;
  font-size: 20px;
  color: #C0C4CC;

}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.all_wrap {
  width: 100%;
  height: 100%;
  background-color: #F9FAFA;
  padding-bottom: 40px;
}

.title_wrap {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F0F1F3;
  padding: 0 33px 0 16px;
}

.left {
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #383E49;
  position: relative;

}

.border_bottom {
  width: 75px;
  height: 2px;
  background: #1366D9;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 52px;
}

.right {
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #428BF9;

}

.bottom_wrap {
  width: 100%;
  padding: 30px 33px 20px 43px;
}

.first_count {
  margin-bottom: 26px;
}

.left_title {
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #48505E;
  margin-bottom: 2px;
}

.left_name {
  margin: 16px 0;
}

.right_content {
  width: 200px;
}

.blue_btn {
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1366D9;
}

.contact_way {

  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #17233D;
  margin-bottom: 12px;
}

.serve_wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left_serve {
  display: flex;
  align-items: center;
}

.blue_title {
  color: #1366D9;
}

.serve_img {
  padding: 6px;
  background-color: #fff;
}

.po_re {
  position: relative;
}

.right_img {
  position: absolute;
  right: 0;
  top: 0;
}


.blue_col {
  color: #1366D9;
}





/*表格滚动条*/
.el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.25);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

/*滚动条类*/
.scrollbars::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

.scrollbars::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.25);
}

.scrollbars::-webkit-scrollbar-track {
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.el-dialog {
  background-color: #fff !important;
  width: 430px;
  height: 320px;
  background: #FFFFFF;
  border-radius: 4px !important;
}

.el-dialog__header {
  padding: 0;
}

.el-dialog__body {
  padding-top: 10px;
  padding: 10px 40px 20px;
}

.phone_border_bottpm {
  width: 83px;
  border-bottom: 2px solid #428BF9;
  margin-top: 9px;
  padding-bottom: 20px;
}

.pass_border_bottpm {
  width: 83px;
  border-bottom: 2px solid #428BF9;
  padding-bottom: 12px;
}

.top_wrap {
  height: 70px;
  font-family: 'HarmonyOS Sans SC';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #4C4C4C;
  border-bottom: 1px solid #DCDFE6;
}

.el-dialog__headerbtn {
  display: none;
}

.ivu-input,
#getcode2,
#getcode {
  height: 40px !important;
}
</style>



<style lang="scss">
/*滚动条类*/
.scrollbars::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

.scrollbars::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.scrollbars::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

/*通用按钮类*/
.commonbtn {
  background-color: #4184f3;
  color: white;
  border: 1px solid #4184f3;
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtn:hover {
  background-color: #5e9bff;
  border: 1px solid #5e9bff;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtn:focus {
  outline: none;
}

/*通用按钮类*/
.commonbtnol {
  background-color: white;
  color: #4773bb;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtnol:hover {
  background-color: #4184f3;
  border: 1px solid #4184f3;
  color: white;
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s;
  -moz-transition: ease all 0.2s;
  -ms-transition: ease all 0.2s;
}

.commonbtnol:focus {
  outline: none;
}

/* 鼠标经过表格行 */
.hoverline tbody tr {
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s;
  /* Safari and Chrome */
  -moz-transition: ease all 0.2s;
  /* Firefox */
  -ms-transition: ease all 0.2s;
  /* Opera */
}

.hoverline tbody tr:hover {
  background-color: #f7f9ff;
  transition: ease all 0.1s;
  -webkit-transition: ease all 0.1s;
  /* Safari and Chrome */
  -moz-transition: ease all 0.1s;
  /* Firefox */
  -ms-transition: ease all 0.1s;
  /* Opera */
}

/* 查询模块卡片样式 */
.oneFunction_div {
  position: relative;
  width: 100%;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 4px;
  margin-bottom: 20px;
}

.reminder_div .iconfont {
  font-size: 18px;
  vertical-align: middle;
  margin-left: 5px;
  margin-right: 7px;
  font-weight: 500;
  color: #4184f3;
}

.reminder_title {
  font-style: normal;
  font-size: 17px;
  border-bottom: 1px solid rgba(223, 229, 240, .8);
  padding: 10px 15px;
  padding-bottom: 7px;
  color: #4773bb;
}

.reminder_content {
  margin: 16px 45px;
  margin-bottom: 12px;
}

/* 单选按钮 */
.radio-primary {
  display: inline-block;
  cursor: pointer;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 4px;
  height: 35px;
  line-height: 35px;
  min-width: 100px;
  margin-bottom: 12px;
  max-width: 150px;
  padding-right: 12px;
}

.radio-primary:focus {
  border: 1px solid #2d8cf0 !important;
  outline: none;
}

.radio-primary:focus .radio-primary label {
  color: #2d8cf0;
}

.radio-primary label {
  cursor: pointer;
  vertical-align: middle;
  font-weight: 500;
}

/* 时间范围 */
.timepicker-div {
  margin: -8px 0px 0px 28px;
  overflow: hidden;
}

.Yearselect /deep/ .ivu-select {
  position: absolute !important;
  width: 215px !important;
}

.Yearselect .ivu-select {
  position: absolute !important;
  width: 215px !important;
}

.Yearselect /deep/ .ivu-select-selection {
  height: 32px !important;
  border: none !important;
  box-shadow: none !important;
  line-height: 30px !important;
}

.Yearselect .ivu-select-selection {
  height: 32px !important;
  border: none !important;
  box-shadow: none !important;
  line-height: 30px !important;
  border-radius: 0;
}

.Yearselect /deep/ .ivu-select-placeholder {
  line-height: 35px !important;
  font-size: 12px;
}

.Yearselect .ivu-select-placeholder {
  line-height: 35px !important;
  font-size: 12px;
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar {
  width: 5px;
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar {
  width: 5px;
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.Yearselect /deep/ .clearoptions {
  text-align: center;
  color: rgb(199, 200, 208);
  border-radius: 4px;
  display: inline-block;
  height: 25px;
  width: 50px;
  position: relative;
  left: 135px;
  top: 5px;
  padding: 0px;
  margin: 0px;
  background-color: inherit;
  line-height: 22px;
  border: none;
  font-size: 12px;
}

.Yearselect .clearoptions {
  text-align: center;
  color: rgb(199, 200, 208);
  border-radius: 4px;
  display: inline-block;
  height: 25px;
  width: 50px;
  position: relative;
  left: 135px;
  top: 5px;
  padding: 0px;
  margin: 0px;
  background-color: inherit;
  line-height: 22px;
  border: none;
  font-size: 12px;
}

.Yearselect /deep/ .clearoptions:hover {
  background-color: #fafafa;
  color: #515A6E;
}

.Yearselect .clearoptions:hover {
  background-color: #fafafa;
  color: #515A6E;
}

.Yearselect /deep/ .clearoptions:hover .clearoi {
  color: #515A6E !important;
}

.Yearselect .clearoptions:hover .clearoi {
  color: #515A6E !important;
}

.Yearselect /deep/ .clearoptions:focus {
  outline: none !important;
}

.Yearselect .clearoptions:focus {
  outline: none !important;
}

.yeardatepickr /deep/ .ivu-input {
  padding-right: 32px !important;
  padding-left: 10px;
  border: none;
  box-shadow: none;
}

.yeardatepickr .ivu-input {
  padding-right: 32px !important;
  padding-left: 10px;
  border: none;
  box-shadow: none;
}

.yeardatepickr /deep/ .ivu-input-suffix {
  width: 40px;
}

.yeardatepickr .ivu-input-suffix {
  width: 40px;
}

.Yearselect /deep/ .ivu-select-disabled .ivu-select-selection {
  background-color: #fafafa;
  cursor: default;
}

.Yearselect .ivu-select-disabled .ivu-select-selection {
  background-color: #fafafa;
  cursor: default;
}

.reminder_content /deep/ ivu-picker-panel-body {
  z-index: 1000 !important;
}

.reminder_content ivu-picker-panel-body {
  z-index: 1000 !important;
}

.icon-nian {
  color: #ccc !important;
  margin-left: 3px !important;
}

.timepicker {
  height: 35px;
  width: 200px;
  float: left;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 3px;
}

.timepicker-header {
  height: 33px;
  float: left;
  width: 45px;
  padding: 0px 10px;
  background: #FAFAFA;
  text-align: center;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
  color: #ccc;

  &>span {
    line-height: 32px;
    height: 35px;
    float: left;
    vertical-align: middle;
  }
}

.timepicker-input {
  overflow: hidden;
  height: 32px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;

  input {
    padding: 0px 8px;
    border: none;
    outline: none;
    color: #515a6e;
    cursor: pointer;
    transition: ease all 0.4s;
    -webkit-transition: ease all 0.4s;
    -moz-transition: ease all 0.4s;
    -ms-transition: ease all 0.4s;
  }
}

input[type="radio"],
input[type="checkbox"] {
  line-height: normal;
  margin-left: 11px;
  margin-right: 3px;
  cursor: pointer;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 11px;
  color: #ccc;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 11px;
  color: #ccc;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 11px;
  color: #ccc;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 11px;
  color: #ccc;
}

.icon-riqi {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -27px;
  left: 122px;
}

.icon-riqi {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -27px;
  left: 122px;
}

.ivicon {
  color: #808695 !important;
  position: relative;
  top: -31px;
  left: 127px;
  font-size: 16px;
  line-height: 32px;
}

.icon-kaishishijian,
.icon-jieshushijian {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -26px;
  left: -10px;
}

/* 时间范围模块提示文字 */
.tip {
  font-size: 11px;
  color: #4773bb;
  font-weight: 500;
  margin-top: 20px;
}

.tipleft {
  float: left;
  position: relative;
  left: -30px;
}

.tipright {
  float: right;
  position: relative;
  right: -30px;
}

.underline {
  text-decoration: underline;
}

/* 代码选择穿梭框 */
.field-select-fieldlist {
  height: 245px;
  overflow: hidden;
  margin-top: 10px;

  li {
    padding-left: 15px;
    width: 100%;
    border-bottom: 1px solid rgba(223, 229, 240, 0.8);
    cursor: pointer;
    height: 32px;
    line-height: 32px;

    &:first-child {
      border-top: 1px solid rgba(223, 229, 240, 0.8);
    }

    &:hover {
      background-color: #f2f7fe;
    }
  }
}

.ivu-alert-info {
  border: 1px solid #c4d6ff;
  background-color: #f2f6ff;
}

.field-select-fieldlist:hover {
  overflow: auto;
}

ul {
  padding-left: 10px;

  li {
    list-style: none;
    padding-top: 1px;
  }
}

.field-select-search {
  /* width: 100%; */
  border: 1px solid rgba(223, 229, 240, 0.8);
  overflow: hidden;
  position: relative;
  margin: 10px;
  border-radius: 3px;

  &>input {
    border: none;
    width: 100%;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    float: left;
    padding-left: 15px;
    padding-right: 25px;
  }

  &>span {
    position: absolute;
    cursor: pointer;
    right: 2px;
    float: right;
    height: 35px;
    line-height: 35px;
    font-weight: 600 !important;
  }
}

.field-select-search input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.fieldSelect_body_div {
  //width: 800px;
  margin: 15px 45px;
}

.fieldSelect_content_div {
  &>div {
    float: left;
    width: 48%;

    &+div {
      margin-left: 15px;
    }
  }
}

.field-select-header {
  padding-left: 12px;
  width: 100%;
  overflow: hidden;

  span {
    vertical-align: middle;
    height: 35px;
    line-height: 28px;
  }

  &>button {
    float: right;
    height: 32px;
    background-color: white;
    color: #515a6e;
    border-radius: 6px;
    outline: none;
    font-size: 12px;
    padding: 0px 13px;
    border: none;
  }

  &>button:hover {
    color: rgba(0, 0, 0, .85);
    background: rgba(0, 0, 0, .018);
    border-color: transparent;
  }
}

/* 穿梭框左侧选项 */
.oneSelectOption_div,
.oneSelectedOption_div {
  height: 35px;
  border-top: 1px solid rgba(223, 229, 240, 0.8);
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  font-size: 12px;
}

.oneSelectedOption_div:hover,
.oneSelectOption_div:hover {
  background: #f2f7fe;
  color: #4184f3;
}

.oneSelectOption_div:first-child {
  border-top: 0px;
}

.oneSelectedOption_div:first-child {
  border-top: 0px;
}

.oneSelectOption_div:last-child {
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.oneSelectedOption_div:last-child {
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.icon-jiaohuan {
  position: absolute;
  left: 330px;
  top: 200px;
  font-size: 32px !important;
  color: rgba(65, 132, 243, 0.35) !important;
}

.stockCodeSelect_div {
  width: 300px !important;
  height: 35px !important;
  border: 1px solid #ccc;
  margin-left: 28px;
  float: left;
}

.add-stockSelect-button {
  height: 35px;
  width: 35px;
  border-radius: 35px;
  border: 0px;
  background: #347abf;
  margin-left: 25px;
  outline: none;
  cursor: pointer;
  position: relative;
  // background: url("../assets/index/add.png") no-repeat;
}

.condition_head_table {
  width: 100%;
  border: 1px solid #ccc;

  th,
  td {
    border-right: 1px solid #ccc;
  }

  tr {
    border-bottom: 1px solid #ccc;
  }
}

.stockCodeSelect_inputAndButton_div {
  width: 700px !important; // display: none;
}

.stockCodeInput_inputAndButton_div {
  width: 100% !important;
  display: none;
}

.downloadtemplate {
  float: right;
  position: absolute;
  right: 45px;
  top: 165px;
}

.downloadtemplate a {
  color: #515a6e;
  opacity: .7;
  width: 100px;
  display: inline-block;
  text-align: center;
  height: 30px;
  line-height: 28px;
  border: 1px solid rgba(223, 229, 240, 1);
  border-radius: 4px;
  font-size: 14px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.downloadtemplate a:hover {
  color: #4184f3;
  border: 1px solid #4184f3;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.downloadtemplate a:focus {
  color: #4184f3;
  border: 1px solid #4184f3;
  outline: none;
  text-decoration: none;
}

.function_condition_setting_div .oneFunction-header:hover {
  background-color: #dceefb !important;
  /*color:white;*/
}

.stockCodeSelect_select_body {
  width: 700px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}

all_stockCode_name_div {}

.all_stockCode_name_div,
.stockCode_selected_div {
  height: 340px;
  width: 320px;
  float: left;
  border-radius: 5px;
  border: 1px solid rgba(223, 229, 240, 0.8);
  margin-bottom: 12px;
  /*box-shadow: 0 1px 6px 0 rgba(0,0,0,.12), 0 1px 6px 0 rgba(0,0,0,.12)*/
}

.ico_right_div {
  position: absolute;
  left: 350px;
  /*top: 125px;*/
  height: 300px;
  width: 1px;
  background: #ccc;
}

.select_head_div {
  width: 100%;
  height: 35px;
  background: #4184f3;
  padding-left: 15px;
  color: white;
  font-size: 14px;
  line-height: 35px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.stockCode_name_body_div,
.selected_body_div {
  height: 249px;
  width: 100%;
  overflow: auto;
  margin-bottom: 10px;
  border-top: 1px solid rgba(223, 229, 240, 0.35);
}


.stock_loading_div {
  text-align: center;
  height: 100%;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
  }
}


/* 未改动 */
$btncolor: #5292c4;
$border-liner: 1px solid $btncolor;
$border-bold-liner: 2px solid rgb(75, 68, 68);

.add-keywords-button {
  width: 139px;
  height: 32px;
  font-weight: 500;
  text-align: center;
  line-height: 30px;
  margin-bottom: 0px;
  cursor: pointer;
  background-color: white;
  color: #515A6E;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 4px;
  font-size: 12px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  display: inline-block;
}

.add-keywords-button:hover {
  background-color: white;
  color: #4184f3;
  border: 1px solid #4184f3;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.moreFunction_div {
  width: 100%;
  border: 1px solid #ccc;
  min-height: 400px;
  position: relative;
  margin: 40px 0px;
}

.simpledata_table,
.preview_simpledata_table {
  width: 100%;
}

/* 固定表头 */
.stickythead {
  border-top: none !important;
}

.stickythead th {
  position: sticky;
  top: 0;
  background: #ecf2fe;
  ;
}

.theadDivBox th {
  background: #ecf2fe;
  white-space: nowrap;
  padding: 0 10px;
  height: 30px;
  border-top: none !important;
}

.table-bordered>thead>tr>th,
.table-bordered>tbody>tr>th,
.table-bordered>tfoot>tr>th,
.table-bordered>thead>tr>td,
.table-bordered>tbody>tr>td,
.table-bordered>tfoot>tr>td {
  border: 1px solid rgba(223, 229, 240, 0.8);
}

.tbodyDiv {
  background: #fff;
}

.tbodyDiv tr {
  height: 25px;
}

.tbodyDiv td {
  white-space: nowrap;
  padding: 0 10px;
}


.table-footer {
  margin-top: 0px;
  margin-bottom: 20px;
  float: right;
}

#previewbtn {
  width: 115px;
  height: 40px;
  background: white;
  color: #515A6E;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 30px;
  font-size: 16px;
  margin-right: 15px;
}

#previewbtn:after {
  content: '数据预览';
  font-size: 90%;
  margin-left: 2px;
}

#previewbtn:hover,
#previewbtn:focus {
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
}

#bownloadbtn {
  width: 40px;
  height: 40px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  background: white;
  color: #4184f3;
  border: 1px solid rgba(223, 229, 240, 0.8);
  font-size: 18px;
  font-weight: 700;
}

#bownloadbtn:hover {
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
  width: 90px;
  border-radius: 30px;
  transition: ease all 0.3s;
  -webkit-transition: ease all 0.3s;
  -moz-transition: ease all 0.3s;
  -ms-transition: ease all 0.3s;
}

#bownloadbtn:hover::after {
  content: '下载';
  font-size: 14px;
  position: relative;
  top: -2px;
  animation: myfirst 0.4s;
  -webkit-animation: myfirst 0.4s;
  /* Safari and Chrome */
  -moz-animation: myfirst 0.4s;
  /* Firefox */
  -o-animation: myfirst 0.4s;
  /* Opera */
}

#bownloadbtn:focus {
  width: 90px;
  border-radius: 30px;
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
}

#bownloadbtn:focus::after {
  content: '下载';
  font-size: 14px;
  position: relative;
  top: -2px;
}

@keyframes myfirst {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes myfirst

/* Firefox */
  {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes myfirst

/* Safari and Chrome */
  {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes myfirst

/* Opera */
  {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}


.PreviewLoading_div {
  text-align: center;
  height: 380px;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
  }
}

.downloadSummary_div {
  //width: 965px;
  // min-height: 250px;
  margin: 0 auto;
}

.downloadSummary_top_div {
  height: 40px;
  width: 115px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
}

.downloadSummary_table_div {
  width: 100%;
  border: 1px solid #f0f0f0;
}

.downloadSummary_table tr {
  border-bottom: 1px #c1c1c1 solid;
}

.title_td {
  padding: 16px 24px;
  color: #4773bb;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5715;
  text-align: start;
  white-space: nowrap;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
}

.value_td {
  padding: 16px 13px;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
  display: table-cell;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  line-height: 1.5715;
  word-break: normal;
  overflow-wrap: break-word;
  color: #4773bb;
}

.download_bottomInfo_div {
  margin: 0 auto;
  height: 40px;
  width: 50%;
  margin-top: 30px;
}

.addToDownList {
  height: 38px;
  margin-top: 10px;
  margin-bottom: 10px;
  float: right;
}

.download_button {
  width: 135px;
  height: 38px;

}

.preview_sampleData_table_div {
  /*width:1100px;
    height: 480px; */
  overflow: auto;
  max-height: 380px;
  max-width: 1120px;
}

.beginDate_div {
  float: left;
  border: 2px $btncolor solid;
  margin-right: 20px;
  color: white;
}

.endDate_div {
  float: left;
  border: 2px $btncolor solid;
  color: white;
}

.radio_btn {
  display: inline-block;
  width: 14px !important;
  height: 14px !important;
  border-radius: 30px;
  border: 1px solid #0e76bc;
  position: relative;
  vertical-align: middle;
  top: -2px;
}

.radio_btn input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -5px;
  left: 0;
  z-index: 100;
  opacity: 0;
}

.radio_btn span {
  background: black;
  width: 14px;
  height: 14px;
  display: inline-block;
  position: absolute;
  z-index: 15;
  top: -1px;
  left: -1px;
  border-radius: 10px;
  background: #5eb346;
}

.radio_btn input[type="radio"]+span {
  opacity: 0;
}

.radio_btn input[type="radio"]:checked+span {
  opacity: 1;
}

#keywordsinput {
  width: 465px;
  height: 32px;
  line-height: 32px;
  border: 1px solid rgba(223, 229, 240, 0.8);
  padding-left: 10px;
  border-radius: 4px 0 0 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  display: inline-block;
  vertical-align: bottom;
}

#keywordsinput:hover {
  border: 1px solid rgba(65, 132, 243, .8);
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

#keywordsinput:focus {
  outline: none;
  border: 1px solid rgba(65, 132, 243, .8);
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.inquirebtn {
  height: 32px;
  width: 70px;
  font-size: 15px;
  border-radius: 0 5px 5px 0;
}

.inquirebtn2 {
  height: 32px;
  width: 140px;
  font-size: 15px;
  margin-left: 1%;
  margin-right: 1%;
  border-radius: 5px 5px 5px 5px;
  position: absolute;
}

.inquirebtn3 {
  height: 32px;
  width: 70px;
  font-size: 15px;
  border-radius: 5px 5px 5px 5px;
  margin-left: 157px;
  position: absolute;
}

@media (min-width: 1560px) {
  .fieldSelect_content_div {
    &>div {
      float: left;
      width: 48%;

      &+div {
        margin-left: 15px;
      }
    }
  }
}

@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .fieldSelect_content_div {
      &>div {
        float: left;
        width: 48%;

        &+div {
          margin-left: 15px;
        }
      }
    }
  }
}

//
@media (min-width: 1220px) {
  @media (max-width: 1420px) {
    .fieldSelect_content_div {
      &>div {
        float: left;
        width: 47%;

        &+div {
          margin-left: 15px;
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  @media (max-width: 1220px) {
    .fieldSelect_content_div {
      &>div {
        float: left;
        width: 46%;

        &+div {
          margin-left: 15px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .fieldSelect_content_div {
    &>div {
      float: left;
      width: 45%;

      &+div {
        margin-left: 15px;
      }
    }
  }
}

.aaaa {
  position: relative;
}

.ivu-steps-head {
  height: 28px;
  padding-right: 5px;
}

.aaaa /deep/ .ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.aaaa /deep/ .ivu-steps-head-inner {
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: 6px;
  margin-left: 6px;
}

.aaaa /deep/ .ivu-icon-ios-checkmark {
  font-size: 32px !important;
  margin-top: -1px !important;
  margin-left: -1px !important;
}

.aaaa /deep/ .ivu-steps-content {
  color: #999;
  margin-left: 12px !important;
}

.aaaa /deep/ .ivu-steps-tail>i {
  margin-top: 8px;
}

.aaaa /deep/ .ivu-steps-title {
  margin-top: 10px !important;
}

.aaaa /deep/ .ivu-spin-fix {
  position: relative !important;
  top: 15px;
  left: 15px;
  background-color: rgba(255, 255, 255, 0);
}

.aaaa /deep/ .ivu-spin-fix .ivu-spin-main {
  position: relative !important;
  left: 0px !important;
}

.loader {
  width: 30px;
  height: 30px;
  position: relative;
  margin: 0 auto;
  top: 12px;
}

.ivu-steps-item {
  padding-top: 10px;
}

.ivu-steps .ivu-steps-tail {
  margin-top: 8px;
}

.ivu-steps .ivu-steps-head {
  margin-left: 0px !important;
  padding-left: 10px !important;
}

.ivu-steps-horizontal .ivu-steps-content {
  padding-left: 47px;
}

.circular {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round
}

@-webkit-keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@-webkit-keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}

@keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}

.rolelogin {
  border-bottom: 1px dashed #000;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  /* Safari and Chrome */
  -moz-transition: ease all 0.4s;
  /* Firefox */
  -ms-transition: ease all 0.4s;
  /* Opera */
}

.rolelogin:hover {
  border-bottom: 1px solid #4184f3;
  color: #4184f3;
  cursor: pointer;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  /* Safari and Chrome */
  -moz-transition: ease all 0.4s;
  /* Firefox */
  -ms-transition: ease all 0.4s;
  /* Opera */
}

.asterisk {
  padding-right: 10px;
  vertical-align: sub;
}

.alertclass /deep/ .ivu-alert-with-desc .ivu-alert-message {
  color: #4773bb;
  border-bottom: 1px solid #c4d6ff;
  padding-bottom: 8px;
}

.alertclass /deep/ .ivu-alert-info {
  padding-top: 10px;
}

.yearButton {
  display: none !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
